// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.activation-page-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 70vh;
  padding: 20px;
}

.activation-status-container {
  text-align: center;
  padding: 30px;
  width: 70%;
  max-width: 400px;
  min-height: 150px;
  border: 1px solid #ccc;
  border-radius: 20px;
  background-color: #a5d6aa;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.activation-heading {
  font-size: 24px;
  margin-bottom: 20px;
  color: #000;
  font-weight: 600;
}

.activation-content {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.activation-text {
  font-size: 16px;
  color: #333;
  line-height: 1.4;
}

.success-message {
  font-weight: 600;
  font-size: 17px;
  text-align: center; 
  margin: 0 auto; 
  width: 100%; 
}

.instruction {
  margin-top: 10px;
  font-size: 15px;
  text-align: center; 
  width: 100%; 
}

.activation-check-btn,
.activation-logout-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 20px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  margin: 10px auto 0; 
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 40%; 
  max-width: 200px; 
}

.activation-check-btn {
  background-color: #2e7d32;
  color: white;
}

.activation-logout-btn {
  background-color: #ff4d4d;
  color: white;
}

.activation-check-btn:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.activation-check-btn:hover:not(:disabled),
.activation-logout-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.logout-icon {
  font-size: 18px;
}

/* Modal Styles */
.activation-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.activation-modal-content {
  background: #a5d6aa;
  padding: 30px;
  border-radius: 15px;
  box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.15);
  text-align: center;
  width: 350px;
  max-width: 90%;
}

.activation-modal-buttons {
  margin-top: 20px;
  display: flex;
  justify-content: space-evenly;
}

.activation-confirm-btn {
  background-color: #ff4d4d;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}

.activation-confirm-btn:hover {
  background-color: #e04343;
}

.activation-cancel-btn {
  background-color: #dddddd;
  color: #333333;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}

.activation-cancel-btn:hover {
  background-color: #c7c7c7;
}

/* Mobile responsiveness */
@media (max-width: 600px) {
  .activation-status-container {
    width: 85%;
    padding: 25px;
  }

  .activation-heading {
    font-size: 22px;
    margin-bottom: 15px;
  }

  .activation-text {
    font-size: 15px;
  }

  .activation-check-btn,
  .activation-logout-btn {
    padding: 8px 16px;
    font-size: 14px;
  }
}

@media (max-width: 400px) {
  .activation-status-container {
    width: 90%;
    padding: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/AccountActivationPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,4CAA4C;EAC5C,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;EACE;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,UAAU;IACV,aAAa;EACf;AACF","sourcesContent":[".activation-page-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 70vh;\n  padding: 20px;\n}\n\n.activation-status-container {\n  text-align: center;\n  padding: 30px;\n  width: 70%;\n  max-width: 400px;\n  min-height: 150px;\n  border: 1px solid #ccc;\n  border-radius: 20px;\n  background-color: #a5d6aa;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.activation-heading {\n  font-size: 24px;\n  margin-bottom: 20px;\n  color: #000;\n  font-weight: 600;\n}\n\n.activation-content {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.activation-text {\n  font-size: 16px;\n  color: #333;\n  line-height: 1.4;\n}\n\n.success-message {\n  font-weight: 600;\n  font-size: 17px;\n  text-align: center; \n  margin: 0 auto; \n  width: 100%; \n}\n\n.instruction {\n  margin-top: 10px;\n  font-size: 15px;\n  text-align: center; \n  width: 100%; \n}\n\n.activation-check-btn,\n.activation-logout-btn {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 20px;\n  font-size: 15px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin: 10px auto 0; \n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 40%; \n  max-width: 200px; \n}\n\n.activation-check-btn {\n  background-color: #2e7d32;\n  color: white;\n}\n\n.activation-logout-btn {\n  background-color: #ff4d4d;\n  color: white;\n}\n\n.activation-check-btn:disabled {\n  background-color: #cccccc;\n  cursor: not-allowed;\n}\n\n.activation-check-btn:hover:not(:disabled),\n.activation-logout-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.logout-icon {\n  font-size: 18px;\n}\n\n/* Modal Styles */\n.activation-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.activation-modal-content {\n  background: #a5d6aa;\n  padding: 30px;\n  border-radius: 15px;\n  box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.15);\n  text-align: center;\n  width: 350px;\n  max-width: 90%;\n}\n\n.activation-modal-buttons {\n  margin-top: 20px;\n  display: flex;\n  justify-content: space-evenly;\n}\n\n.activation-confirm-btn {\n  background-color: #ff4d4d;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.activation-confirm-btn:hover {\n  background-color: #e04343;\n}\n\n.activation-cancel-btn {\n  background-color: #dddddd;\n  color: #333333;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.activation-cancel-btn:hover {\n  background-color: #c7c7c7;\n}\n\n/* Mobile responsiveness */\n@media (max-width: 600px) {\n  .activation-status-container {\n    width: 85%;\n    padding: 25px;\n  }\n\n  .activation-heading {\n    font-size: 22px;\n    margin-bottom: 15px;\n  }\n\n  .activation-text {\n    font-size: 15px;\n  }\n\n  .activation-check-btn,\n  .activation-logout-btn {\n    padding: 8px 16px;\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 400px) {\n  .activation-status-container {\n    width: 90%;\n    padding: 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
